import { Controller } from "@hotwired/stimulus"
import L from "leaflet"


export default class extends Controller {
    static values = {
        markers: Array,
        departmentCode: String,
        centerLat: Number,
        centerLng: Number
    }
    static targets = ["container"]

    connect() {
        this.initMap()
    }

    initMap() {
        // Determine center/zoom
        const center = (this.hasCenterLatValue && this.hasCenterLngValue) 
            ? [this.centerLatValue, this.centerLngValue] 
            : [48.8566, 2.3522];

        // Initialize map on the target container, fallback to element if strictly needed but target is safer
        const element = this.hasContainerTarget ? this.containerTarget : this.element
        this.map = L.map(element, {
            zoomControl: false,
            dragging: true, // Allow panning on desktop/mobile if needed, but keeping simple
            scrollWheelZoom: false,
            doubleClickZoom: false,
            boxZoom: false,
            keyboard: false,
            touchZoom: false
        }).setView(center, 10)

        L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
            maxZoom: 19,
            attribution: '© OpenStreetMap'
        }).addTo(this.map)

        if (this.hasDepartmentCodeValue && this.departmentCodeValue) {
            this.drawDepartmentContour(this.departmentCodeValue)
        }

        this.addMarkers()
    }

    drawDepartmentContour(code) {
        fetch(`https://geo.api.gouv.fr/departements?code=${code}&geometry=contour`)
            .then(response => response.json())
            .then(data => {
                if (data.length > 0 && data[0].contour) {
                    const geojsonLayer = L.geoJSON(data[0].contour, {
                        style: {
                            color: '#75a5c3', // brand-300
                            weight: 3,
                            opacity: 0.9,
                            dashArray: '8, 8',
                            fillColor: '#75a5c3',
                            fillOpacity: 0.1
                        }
                    }).addTo(this.map)


                }
            })
            .catch(e => console.error("Erreur chargement contour département:", e))
    }

    addMarkers() {
        if (!this.hasMarkersValue || this.markersValue.length === 0) return

        const bounds = L.latLngBounds()

        this.markersValue.forEach((marker) => {
            if (marker.lat && marker.lng) {
                const popupContent = `
          <div class="text-center font-sans">
            <h3 class="font-bold text-base mb-1">${marker.name}</h3>
            ${marker.link ? `<a href="${marker.link}" class="text-brand-600 hover:text-brand-700 underline text-sm">Voir la ville</a>` : ''}
          </div>
        `

                // Use CircleMarker for red points - easier to handle than custom icons and looks modern
                const markerOptions = {
                    radius: 8,
                    fillColor: "#ef4444", // red-500
                    color: "#b91c1c", // red-700
                    weight: 1,
                    opacity: 1,
                    fillOpacity: 0.8
                }

                L.circleMarker([marker.lat, marker.lng], markerOptions)
                    .addTo(this.map)
                    .bindPopup(popupContent)

                bounds.extend([marker.lat, marker.lng])
            }
        })

        if (!this.hasDepartmentCodeValue && bounds.isValid()) {
            this.map.fitBounds(bounds, { padding: [50, 50] })
        }
    }
}

